// extracted by mini-css-extract-plugin
module.exports = {"container":"VideoPass_container__2d0DG","explainer":"VideoPass_explainer__16orP"};